import { LineItem, Payment } from 'shared/types/cart';
import { EnumAttribute } from 'shared/types/product';
import { centsToDollarString } from 'helpers/priceHelpers';
import { CourseDetails } from './types';

export const getCoursesDetails = (
  lineItems: Required<LineItem>[],
): CourseDetails[] =>
  lineItems.map(
    ({ name, price, variant: { sku, images, attributes = {} } }) => ({
      name,
      sku,
      url: `${process.env.NEXT_PUBLIC_LEARNING_BASE_URL!}/course/${sku}/home`,
      image: images?.[0],
      price: centsToDollarString(price.centAmount, price.fractionDigits),
      partner: attributes['brand-text'],
      startDate: attributes['courserun-start']!,
      duration: {
        low: attributes['duration-low'],
        high: attributes['duration-high'],
        unit: attributes['duration-unit']?.label,
      },
    }),
  );

/**
 * Get the latest payment method from the payments array in a human-readable format
 */
export const getPaymentMethod = (payments: Payment[]) => {
  const paymentMethod = payments?.at(-1)?.paymentMethod ?? 'card';
  return paymentMethod === 'paypal'
    ? 'PayPal'
    : paymentMethod.replace(/_/g, ' ');
};

export const formatProgramType = (type: EnumAttribute) => {
  if (!type) {
    return 'Program';
  }

  const { label, key } = type;

  switch (key) {
    case 'micromasters':
    case 'microbachelors':
      return (
        <span>
          &nbsp;
          {label}
          <sup>&reg;</sup> Program
        </span>
      );
    case 'masters':
      return <span>&nbsp;Master&apos;s</span>;
    case 'xseries':
      return `${label} Program`;
    default:
      return label;
  }
};
